import { Outlet } from 'react-router';
import { Navbar } from '@/components/marketing/Navbar';
import { Footer } from '@/components/marketing/Footer';
import { StickyCTA } from '@/components/marketing/StickyCTA';

/**
 * Marketing site layout wrapper
 * - Dark theme scoped here — does NOT affect body or app dashboard
 * - Renders Navbar at top
 * - Main content area with Outlet for nested routes
 * - Footer pushed to bottom with flexbox
 * - Sticky CTA bar that appears on scroll
 */
export function MarketingLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-[#0c0c0c] font-mkt-sans text-[#a8a29e]">
      <Navbar />
      <StickyCTA />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
